// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React from 'react';
import dateFormat from 'dateformat';
import { useSelector, useDispatch } from 'react-redux'
import { showModal } from '../actions';
import { COLOR_STARTUS } from '../const'
import { COLOR, ENLISH_STARTUS } from '../const'
import styled from '@emotion/styled'
import ReactTooltip from 'react-tooltip'


const RouteItem = ({ index }: { index: number }) => {

  const route: any = useSelector((state: any) => state.Route.routes[index])
  const { skip } = useSelector((state: any) => state.Search)

  const dispatch = useDispatch();
  const datedilevery = new Date(route.created);
  return (
    <div key={`kdr-${index}`} className={styles.divTableRow} onClick={() => {
      dispatch(showModal(index))
    }}>
      <div className={styles.divTableCell}>{index + 1 + skip}</div>
      <div className={styles.divTableCell}>
        <div className={styles.divStatus}>
          <StyledStatus status={route.status}> {ENLISH_STARTUS[route.status]}</StyledStatus>
          <div className={styles.tracking}>{route.routeNo}</div>
        </div>
      </div>
      <div className={styles.divTableCell}>{route.isBox ? 'มีกล่อง' : 'ไม่มีกล่อง'}</div>
      <div className={styles.divTableCell}>{route.orders[0].shop.name}</div>
      <div className={styles.divTableCell}>
        <div> {dateFormat(datedilevery, "H:MM")}</div>
        <div>{dateFormat(datedilevery, "ddd dd-mm-yyyy")}</div>
      </div>
      <div className={styles.divTableCell}>
        {RouteRow(route.orders, index, route.status)}
      </div>
      <div className={styles.divTableCell}>{(route.driver === undefined ? 'N/A' : route.driver.name)}</div>
      <div className={styles.divTableCell}>{(route.delivery_service === undefined ? 'N/A' : route.delivery_service === 'saranros' ? 'SARANROS' : route.delivery_service === 'lalamove' ? 'LALAMOVE' : 'SKOOTAR')}</div>
      <div className={styles.divTableCell}>{(route.quotation === undefined ? 'N/A' : route.quotation.totalFee)}</div>

    </div>
  );
}

const RouteRow = (orders: Array<any>, id: number, status: string) => {
  return (
    <div key={`rr-${id}`} className={styles.routeRow}>
      <StyledUl status={status}>
        {new Array(orders.length).fill(null).map((_, index: number) => (
          // <>
          <li data-tip data-for={`global-${id}-${index}`} key={index} className={styles.textCircle}>{orders[index].no}
            <ReactTooltip key={`rt-${index}`} className={styles.tooltip} id={`global-${id}-${index}`} type="light" effect="float" >
              <p>
                {orders[index].no}
              </p>
              <p>
                {`ผู้ส่งสินค้า:`}{orders[index].contact.name},{orders[index].contact.mobile}
              </p>
              <p>
                {orders[index].address}
              </p>

            </ReactTooltip>
          </li>
          // </>
        ))}
      </StyledUl>
    </div>

  );
}


const styles = {
  root: css`
      display: flex;
      justify-content: space-between;
      list-style-type: none;
      margin: 0;
      padding: 8px 12px;  
    &:hover {
      background - color: #efefef;

      button {
      display: block;
      }
    }

    button {
      display: none;
    }
`,
  circleBar: css`
  counter-reset: step;
  margin:0;
  padding:10px 0;
  height: 100%;
  width: 560px;
  display: flex;
  li{
    float: left;
    width: 100px;
    position: relative;
    text-align: center;
    list-style: none;
    &:first-child{
      &:after{
        content: none;
      }
    }
    &:before{
      content:counter(step);
      counter-increment: step;
      width: 30px;
      height: 30px;
      border: 1px solid ${COLOR['BLUE_DARK']};
      display: block;
      margin: 0 auto 10px auto;
      border-radius: 50%;
      line-height: 27px;
      background: white;
      color: ${COLOR['BLUE_DARK']};
      text-align: center;
      font-size: 16px;
      z-index: 20;
      position: relative;
    }
    &:after{
      content: '';
      position: absolute;
      width:100%;
      height: 1px;
      background: ${COLOR['BLUE_DARK']};
      top: 15px;
      left: -50%;
      z-index: 10;
    }
  }
  `,
  wrapCircle: css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  `,
  line: css`
  width:  20px;
  height: 1px;
  background-color: ${COLOR['DARK_2']};
 `,
  divTableRow: css`
    display: table-row;
    color: ${COLOR['DARK_2']};
    background-color: #ffffff;
    border: 1px solid #ffffff;
    padding:8px 0;
    &:nth-child(odd) {
      background-color: ${COLOR['BLUE_DARK_OPA_1']};
      border: 1px solid ${COLOR['BLUE_DARK_OPA_1']};
    }
`,
  divTableHeading: css`
    background-color: #ffffff;
    display: table-header-group;
`,
  divTableCell: css`
    // border: 1px solid #999999;
    display: table-cell;
    // padding: 3px 0px;
    text-align: center;
    font-size: 16px;
`,
  modal: css`
    position: absolute;
    height: 100%;
    width: 600px;
    top: 0px;
    right: 0px;
    background: #fff;
  `,
  routeRow: css`;
    height: 100%;
    width: 560px;
    display: flex;
    `,
  divCircle: css`;
    // height: 100%;
    // width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // padding:15px 5px;
    `,
  itemCircle: css`
    // height: 100%;
    // width: 100%;
    display: flex;
  justify-content: center;
    `,
  routeCircle: css`
    height: 26px;
    width: 26px;
    border: solid 1px ${COLOR['BLUE_DARK']};
    color: ${COLOR['BLUE_DARK']};
    border-radius: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    `,
  textCircle: css`
    font-size: 10px;
    margin-top:5px;
    color: ${COLOR['DARK_2']};
    `,
  tracking: css`
    font-size: 12px;
    color: ${COLOR['DARK_2']};
    padding:5px 0;
    `,
  divStatus: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    `,
  tooltip: css`
      text-align: left;
      font-weight: bold;
      font-size: 14px;
       p:last-child {
        font-weight: normal;
       }
    `,
};


type StyledComponentProps = {
  status: string
}

const StyledUl = styled('ul') <StyledComponentProps>`
counter-reset: step;
  margin:0;
  padding:10px 0;
  height: 100%;
  width: 560px;
  display: flex;
  li{
    float: left;
    width: 100px;
    position: relative;
    text-align: center;
    list-style: none;
    &:first-child{
      &:after{
        content: none;
      }
    }
    &:before{
      content:counter(step);
      counter-increment: step;
      width: 30px;
      height: 30px;
      border: 1px solid ${props => {
    if (props.status === 'COMPLETED' || props.status === 'CANCELED' || props.status === 'ERROR') {
      return COLOR_STARTUS[props.status]
    }
    return COLOR['BLUE_DARK']
  }};
      display: block;
      margin: 0 auto 10px auto;
      border-radius: 50%;
      line-height: 27px;
      background: ${props => {
    if (props.status === 'COMPLETED' || props.status === 'CANCELED' || props.status === 'ERROR') {
      return COLOR_STARTUS[props.status]
    }
    return 'white'
  }};
      color: ${props => {
    if (props.status === 'COMPLETED' || props.status === 'CANCELED' || props.status === 'ERROR') {
      return 'white'
    }
    return COLOR['BLUE_DARK']
  }};
      text-align: center;
      font-size: 16px;
      z-index: 20;
      position: relative;
    }
    &:after{
      content: '';
      position: absolute;
      width:100%;
      height: 1px;
      background: ${COLOR['BLUE_DARK']};
      top: 15px;
      left: -50%;
      z-index: 10;
    }
  }
`;

const StyledStatus = styled('div') <StyledComponentProps>`
    line-height: 20px;
    color: #ffffff;
    font-size: 14px;
    width: 140px;
    background: ${props => COLOR_STARTUS[props.status]};
    border-radius: 7px;
    text-align: center;
  `;

export default RouteItem;